
import React, { useEffect, useState } from 'react';
import { Button, TextField, Grid, Container, Typography,FormControl,InputLabel,Select,MenuItem,FormHelperText } from '@mui/material';
import axios from 'axios'; 
import ImageUpload from '../RepresentativeEdit/ImageUpload';
import Office from '../RepresentativeEdit/Office';
import { decrypt,encrypt } from '../../Security';

const CreateRepresentative = () => {
  const [repId,setRepId]=useState(null)
  const [userId,setUserId]=useState('')
  const [name,setName]=useState('')
  const [position,setPosition]=useState('')
  const [term,setTerm]=useState('')
  const [adminArea,setAdminArea]=useState('')
  const [electedArea,setElectedArea]=useState('')
  const [email,setEmail]=useState('')
  const [dob,setDob]=useState('')
  const [pob,setPob]=useState('')
  const [party,setParty]=useState('')
  const [state,setState]=useState('')
 
  const [socialMedia,setSocialMedia]=useState({ linkedin: '', twitter: '', facebook: '', instagram: '', website: '' })
 
  const [officeLocations,setOfficeLocations]=useState([])
  const [base64Image, setBase64Image] = useState('');
  const [errors, setErrors] = useState({});

  const statesName=['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming']


 
  const resetAll=async()=>{
    
    console.log("setting uid inside resetALL()")
    setRepId('')
    setUserId('')
    setName('')
    setPosition('')
    setTerm('')
    setAdminArea('')
    setElectedArea('')
    setEmail('')
    setDob('')
    setPob('')
    setParty('')
    setState('')
 
    setSocialMedia({ linkedin: '', twitter: '', facebook: '', instagram: '', website: '' })
    setOfficeLocations([])
    setBase64Image('')
    setErrors({})
  



  }

  

  const addOfficeLocation=async()=>{  
   

    setOfficeLocations((loc)=>[...loc,{contact:'',address:'',email_id:''}])
  }

  const removeOfficeLoc=async(loc)=>{ 
    const ols=officeLocations.filter((ol)=>ol!=loc)
    setOfficeLocations(ols)
  }

  const uploadData=async()=>{
    
    let repObj={}
   
    if(userId)
    {
      repObj.user_id=userId.trim()
    }
    
    repObj.name=name
    repObj.imagePath=base64Image
    
    repObj.current_elected_position=position
    repObj.administrative_area=adminArea
    repObj.elected_area=electedArea
    repObj.official_email_id=email
    repObj.dob=dob
    repObj.pob=pob
    repObj.party=party
    repObj.state=state
  
    repObj.term_serving=term
    // repObj.experience=experience
    // repObj.educational_qualifications=educational_qualifications
    // repObj.long_term_vision=long_term_vision
    
    
    
    // repObj.my_feeds_id=feedsId.
   
    repObj.social_media_handles= [{ platform: "twitter", handle_id: (!socialMedia.twitter || socialMedia.twitter.trim()=="")?'N/A': socialMedia.twitter.trim()},
    { platform: "facebook", handle_id: (!socialMedia.facebook || socialMedia.facebook.trim()=="")?'N/A': socialMedia.facebook.trim() },
    { platform: "linkedin", handle_id: (!socialMedia.linkedin || socialMedia.linkedin.trim()=="")?'N/A': socialMedia.linkedin.trim() },
    { platform: "instagram", handle_id: (!socialMedia.instagram ||  socialMedia.instagram.trim()=="")?'N/A': socialMedia.instagram.trim()},
    { platform: "website", handle_id: ( !socialMedia.website || socialMedia.website.trim()=="")?'N/A': socialMedia.website.trim() }]
    
    
    repObj.office_locations=officeLocations

    const response = await fetch(process.env.REACT_APP_PUBLIC_SERVER_URI + '/api/v1/submit/reps', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: encrypt({
        repObj,
        repId
      }),
    });
    
    const data = decrypt(await response.json()); // Assuming response contains JSON data
   
   
    if(data.msg){
      alert(data.msg)
    }
    else{
      alert(JSON.stringify(data.error))
    }

     
    
  }

 
 

    
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  

  const validate = () => {
    let tempErrors = {};
    tempErrors.name = name.trim()!=""  ? "" : "This field is required.";
    tempErrors.current_elected_position = position.trim()!=""  ? "" : "This field is required.";
    tempErrors.administrative_area = adminArea.trim()!=""  ? "" : "This field is required.";
    tempErrors.elected_area = adminArea.trim()!=""  ? "" : "";
    tempErrors.official_email_id = email.trim()!="" ? isValidEmail(email) ? "" : "Invalid email format." : "This field is required.";
    tempErrors.state = state.trim()!="" ? "" : "This field is required.";
 
    setErrors(tempErrors);
    return Object.values(tempErrors).every(x => x === "");
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validate()) {
   
      uploadData()
    }
  };


  return (
    <Container component="main" >
       <Grid container justifyContent="flex-end">
         <Button
                onClick={() => resetAll()}
                variant="contained"
                color="error"
                sx={{ marginTop: '20px' }}
              >
                Reset
              </Button>
       </Grid>
      <Typography component="h1" variant="h5">
        Representative Data
      </Typography>
      <form onSubmit={handleSubmit} noValidate>
        <Grid container spacing={2}>
        {/* <Grid item xs={12} style={{marginTop:'20px'}}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
            >
              Submit to Create 
            </Button>
          </Grid> */}
          <Grid  item md={6} xs={12} sm={12}>

         
         

         

          <Grid item xs={12} style={{marginTop:'20px'}}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="name"
              label="Name"
              name="name"
              autoComplete="name"
              value={name}
              onChange={(event)=>setName(event.target.value)}
              {...(errors.name && { error: true, helperText: errors.name })}
            />
             
          </Grid>
          <Grid item xs={12} style={{marginTop:'20px'}}>
            <ImageUpload  base64Image={base64Image}  setBase64Image={setBase64Image} />
          </Grid>


          <Grid item xs={12} style={{marginTop:'20px'}}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="current_elected_position"
              label="Current Elected Position"
              name="current_elected_position"
              autoComplete="current_elected_position"
              value={position}
              onChange={(event)=>setPosition(event.target.value)}
              {...(errors.current_elected_position && { error: true, helperText: errors.current_elected_position })}
            /> 
          </Grid>
 

          <Grid item xs={12} style={{marginTop:'20px'}}>
            <TextField
              variant="outlined"
             
              fullWidth
              id="term_serving"
              label="Term Serving"
              name="term_serving"
              autoComplete="term_serving"
              value={term}
              onChange={(event)=>setTerm(event.target.value)}
              // {...(errors.repId && { error: true, helperText: errors.repId })}
            /> 
          </Grid>

          <Grid item xs={12} style={{marginTop:'20px'}}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="administrative_area"
              label="Administrative Area"
              name="administrative_area"
              autoComplete="administrative_area"
              value={adminArea}
              onChange={(event)=>setAdminArea(event.target.value)}
              {...(errors.administrative_area && { error: true, helperText: errors.administrative_area })}
            /> 
          </Grid>
          <Grid item xs={12} style={{marginTop:'20px'}}>
            <TextField
              variant="outlined"
              // required
              fullWidth
              id="elected_area"
              label="Elected Area"
              name="elected_area"
              autoComplete="elected_area"
              value={electedArea}
              onChange={(event)=>setElectedArea(event.target.value)}
              {...(errors.elected_area && { error: true, helperText: errors.elected_area })}
            /> 
          </Grid>

          <Grid item xs={12} style={{marginTop:'20px'}}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="official_email_id"
              label="Official Email Id"
              name="official_email_id"
              autoComplete="official_email_id"
              value={email}
              onChange={(event)=>setEmail(event.target.value)}
              {...(errors.official_email_id && { error: true, helperText: errors.official_email_id })}
            /> 
          </Grid>

          <Grid item xs={12} style={{ marginTop: '20px' }}>
  <TextField
    variant="outlined"
    fullWidth
    id="dob"
    label="Date of Birth"
    name="dob"
    type="date" // Set the type to "date" for a date picker
    value={dob}
    onChange={(event) => setDob(event.target.value)}
    InputLabelProps={{
      shrink: true, // Ensures the label stays above the input
    }}
  />
</Grid>


          <Grid item xs={12} style={{marginTop:'20px'}}>
            <TextField
              variant="outlined"
            
              fullWidth
              id="pob"
              label="Place of Birth"
              name="pob"
              autoComplete="pob"
              value={pob}
              onChange={(event)=>setPob(event.target.value)}
              // {...(errors.repId && { error: true, helperText: errors.repId })}
            /> 
          </Grid>

          <Grid item xs={12} style={{marginTop:'20px'}}>
            <TextField
              variant="outlined"
              
              fullWidth
              id="party"
              label="Party Name"
              name="party"
              autoComplete="party"
              value={party}
              onChange={(event)=>setParty(event.target.value)}
              // {...(errors.repId && { error: true, helperText: errors.repId })}
            /> 
          </Grid>

          <Grid item xs={12} style={{ marginTop: '20px' }}>
  <FormControl variant="outlined" fullWidth error={!!errors.state}>
    <InputLabel id="state-label">State Name</InputLabel>
    <Select
      labelId="state-label"
      id="state"
      name="state"
      value={state}
      onChange={(event) => setState(event.target.value)}
      label="State Name"
    >
      {statesName.map((stateName) => (
        <MenuItem key={stateName} value={stateName}>
          {stateName}
        </MenuItem>
      ))}
    </Select>
    {errors.state && (
      <FormHelperText>{errors.state}</FormHelperText>
    )}
  </FormControl>
</Grid>



          <Grid item xs={12} style={{marginTop:'20px'}}>
            <h5>Social Media Handles</h5>
            <TextField
              variant="outlined"
              
              fullWidth
              id="website"
              label="Website"
              name="website"
              style={{ marginTop: '15px' }}
              autoComplete="website"
              value={socialMedia.website}
              onChange={(event) => setSocialMedia((old) => ({ ...old, website: event.target.value }))}
              {...(errors.repId && { error: true, helperText: errors.repId })}
            />

            <TextField
              variant="outlined"
           
              fullWidth
              id="linkedin"
              label="LinkedIn"
              style={{ marginTop: '15px' }}
              name="linkedin"
              autoComplete="linkedin"
              value={socialMedia.linkedin}
              onChange={(event) => setSocialMedia((old) => ({ ...old, linkedin: event.target.value }))} 
              {...(errors.repId && { error: true, helperText: errors.repId })}
            />  


            <TextField
              variant="outlined"
            
              fullWidth
              id="facebook"
              label="Facebook"
              name="facebook"
              autoComplete="facebook"
              value={socialMedia.facebook}
              style={{ marginTop: '15px' }}
              onChange={(event) => setSocialMedia((old) => ({ ...old, facebook: event.target.value }))} 
              // {...(errors.repId && { error: true, helperText: errors.repId })}
            />

          <TextField
              variant="outlined"
              
              fullWidth
              style={{ marginTop: '15px' }}
              id="twitter"
              label="Twitter"
              name="twitter"
              autoComplete="twitter"
              value={socialMedia.twitter}
              onChange={(event) => setSocialMedia((old) => ({ ...old, twitter: event.target.value }))}

              // {...(errors.repId && { error: true, helperText: errors.repId })}
            />

        <TextField
              variant="outlined"
           
              fullWidth
              style={{ marginTop: '15px' }}
              id="instagram"
              label="Instagram"
              name="instagram"
              autoComplete="instagram"
              value={socialMedia.instagram}
              onChange={(event) => setSocialMedia((old) => ({ ...old, instagram: event.target.value }))}
              {...(errors.repId && { error: true, helperText: errors.repId })}
            />
            
          </Grid>

          

          
          
          </Grid>

          <Grid item md={6} xs={12} sm={12}>
          <Grid container spacing={2} alignItems="center"  justifyContent="space-evenly" style={{}}>
            <Grid item xs={6}>
              <span style={{fontSize:'17px',fontWeight:'bold',alignContent:'center',marginLeft:'5%'}}>Office Locations</span>
            </Grid>
            <Grid item xs={6}>
              <Button color="primary" onClick={addOfficeLocation}>Add Location</Button>
            </Grid>
          </Grid>

          <Grid item xs={12} style={{marginTop:'30px'}}>
          {officeLocations.map((office,index) => (
              <Office key={index} office={office} officeLocations={officeLocations} setOfficeLocations={setOfficeLocations} index={index} removeOfficeLoc={removeOfficeLoc} />
            ))}
          </Grid>
          </Grid>
          
          



          <Grid item xs={12} style={{marginTop:'20px'}}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
            >
              Submit To create
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default CreateRepresentative;
